module.exports = __webpack_public_path__ + "static/media/workbg-camping.f90bfaf2.jpg";